export class AppConstants {
    static readonly APP_NAME = 'wfm';
    static readonly SESSION_VAR_USER = 'user';
    static readonly SESSION_VAR_TOKEN = 'auth_token';
    static readonly SESSION_VAR_CRM_TOKEN = 'crm_auth_token';
    static readonly SESSION_VAR_SYSTEM_PARAM = 'sys_param';
    static readonly MASTER_ID_MULTI_FACTOR = 10000;

    static readonly UASER_TYPE_HQ = 'HQ';
    static readonly UASER_TYPE_SHOP = 'SHOP';
    static readonly UASER_TYPE_AREA_MANAGER = 'AREA_MANAGER';


    static readonly SESSION_VAR_DEPARTMENT = 'department';
    static readonly SESSION_VAR_SHOP_LIST = 'shop_list';

};

export const SESSION_VAR_STATE = 'page_state';
